import _ from "lodash";

import { DeliveryMethodsEnum } from "../domains2/libraries/DeliveryMethods";
import * as mutationTypes from "../store/mutation-types";
import appConfig from "../appconfig";

export const shouldCartBeEmptied = (newDeliveryMethod, oldDeliveryMethod) => {
	if([newDeliveryMethod, oldDeliveryMethod].includes(DeliveryMethodsEnum.EAT_IN) && newDeliveryMethod !== oldDeliveryMethod) {
		return true;
	}
	return false;
};

export const deliveryStatusEnum = {
	"orderConfirmed": {
		"key": "orderConfirmed",
		"step": 1,
		"name": "utilityComponents.pendingDeliveryOrder.status.orderConfirmed",
		"image": "order-confirmed.png",
		"imageActive": "order-confirmed-active.png"
	},
	"preparingFood": {
		"key": "preparingFood",
		"step": 2,
		"name": "utilityComponents.pendingDeliveryOrder.status.preparingFood",
		"image": "preparing-food.png",
		"imageActive": "preparing-food-active.png"
	},
	"deliveringFood": {
		"key": "deliveringFood",
		"step": 3,
		"name": "utilityComponents.pendingDeliveryOrder.status.foodOnTheWay",
		"image": "food-on-way.png",
		"imageActive": "food-on-way-active.png"
	},
	"deliveredFood": {
		"key": "deliveredFood",
		"step": 4,
		"name": "utilityComponents.pendingDeliveryOrder.status.orderDelivered",
		"image": "order-delivered.png",
		"imageActive": "order-delivered-active.png"
	}
};

export const updateDeliveryAddressFromPersonService = async ({ getters, dispatch }) => {
	const loggedIn = getters.applicationUserLoggedIn;
	const personData = getters.personData;
	if(loggedIn && personData.address && personData.address.address && personData.address.doorFloor) {
		await dispatch(mutationTypes.ADD_DELIVERY_ADDRESS_AND_FLOOR, {
			address: personData.address.address,
			doorFloor: personData.address.doorFloor
		});
	}
};

export const deliveryPhoneNumber = (vuexStore) => {
	const phoneNumber = _.get(vuexStore.getters.tenantSettings, "delivery.contactPhone", "");
	if(phoneNumber === ""){
		return "tel:" + appConfig.tenantConfig.delivery.contactPhone;
	}
	return "tel:" + phoneNumber;
};

export const isDriveThrough = (deliveryChoice) =>  {
	if(!deliveryChoice) {
		return false;
	}
	return deliveryChoice === DeliveryMethodsEnum.DRIVE_THROUGH;
};
